import React from 'react';
import { useNavigate } from 'react-router-dom';

function PortfoyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Portföy Yönetimi</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-3xl font-bold text-[#1e5a8e] mb-4">Portföy Yönetimi Hizmetlerimiz</h2>
          <p className="text-gray-600 leading-relaxed">
            Uzman personelimiz ile yatırımcıların risk tercihleri doğrultusunda 
            amaçladıkları getiriye ulaştırmayı hedefliyoruz.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="w-16 h-16 bg-[#26c6da] rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Bireysel Portföy</h3>
            <p className="text-gray-600">Kişiye özel portföy yönetimi</p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="w-16 h-16 bg-[#1e5a8e] rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Kurumsal Portföy</h3>
            <p className="text-gray-600">Kurumsal yatırımcılara özel çözümler</p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="w-16 h-16 bg-[#26c6da] rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Yatırım Fonları</h3>
            <p className="text-gray-600">Çeşitlendirilmiş yatırım fonları</p>
          </div>
        </div>

        <div className="bg-[#26c6da] bg-opacity-10 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-[#1e5a8e] mb-4">Neden Portföy Yönetimi?</h3>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-2">
              <span className="text-[#26c6da] text-xl">✓</span>
              <span>Profesyonel yönetim ile zaman tasarrufu</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#26c6da] text-xl">✓</span>
              <span>Risk yönetimi ve çeşitlendirme</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#26c6da] text-xl">✓</span>
              <span>Düzenli raporlama ve şeffaflık</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#26c6da] text-xl">✓</span>
              <span>Kişiye özel yatırım stratejileri</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PortfoyPage;
